import CurrencyConverter from "@/components/CustomUI/modules/CurrencyConverter";
import { Button } from "@/components/ui/button";
import Payment from "@/components/CustomUI/modals/Payment";
import { TriangleDots } from "@/components/CustomUI/modules/Loaders";
import usePayment from "./usePayment";

const PaymentButton = () => {

  const {
    loading,
    total_price,
    paymentModal,
    addressValidated,
    onOpenChange,
    handlePress,
  } = usePayment();

  if(!addressValidated) return null;

  return (
    <section className="mb-1 pt-2">
      <div className="flex flex-col gap-y-3 pb-3">
        <Button
          variant="primary"
          className="
              bg-[#45d4d5] rounded-sm text-white group
              px-12 py-0 text-font-primary h-[45px]
              hover:bg-[#56f0f1] border border-slate-300
              w-full text-font-primary text-[12px] md:text-sm  
              xl:text-base font-semibold flex items-center gap-x-2
          "
          onClick={() => handlePress({ prepayment_percentage: 100 })}
        >
          {
            loading && loading === 'pay' ?
              <>
                <span className="text-black">CREATING YOUR ORDER</span> <TriangleDots loading={true} />
              </>
              :
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ffffff"
                  height={23}
                  width={23}
                  version="1.1"
                  viewBox="0 0 330 330"
                  xmlSpace="preserve"
                  className="group-hover:fill-back group-hover:animate-waving-hand"
                >
                  <g id="XMLID_509_">
                    <path d="M65,330h200c8.284,0,15-6.716,15-15V145c0-8.284-6.716-15-15-15h-15V85c0-46.869-38.131-85-85-85   S80,38.131,80,85v45H65c-8.284,0-15,6.716-15,15v170C50,323.284,56.716,330,65,330z M180,234.986V255c0,8.284-6.716,15-15,15   s-15-6.716-15-15v-20.014c-6.068-4.565-10-11.824-10-19.986c0-13.785,11.215-25,25-25s25,11.215,25,25   C190,223.162,186.068,230.421,180,234.986z M110,85c0-30.327,24.673-55,55-55s55,24.673,55,55v45H110V85z" />
                  </g>
                </svg>
                <span className="text-white group-hover:text-black">PAY NOW</span>
                <span className="text-white group-hover:text-black">
                  <CurrencyConverter amount={total_price} />
                </span>
              </>
          }
        </Button>
        <Button
          variant="primary"
          className="
              bg-white rounded-sm
              px-12 py-0 text-font-primary h-[45px]
              hover:bg-white border border-[#45d4d5]
              w-full text-font-primary text-[12px] md:text-sm  
              xl:text-base font-semibold
          "
          onClick={() => handlePress({ prepayment_percentage: 0 })}
        >

          {
            loading && loading === 'delivery' ?
              <>
                <span className="text-black">CREATING YOUR ORDER</span> <TriangleDots loading={true} />
              </> :
              "PAY ON DELIVERY"
          }
        </Button>
      </div>
      <div className="flex md:flex-col lg:flex-row items-center justify-around lg:justify-evenly font-light text-sm italic">
        <div className="flex items-center gap-x-3 pb-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
            height={25}
            width={25}
            version="1.1"
            viewBox="0 0 487.048 487.048"
            xmlSpace="preserve"
          >
            <g>
              <g>
                <g>
                  <path d="M153.723,293.718H16.733c-9.252,0-16.733,7.49-16.733,16.73c0,9.239,7.481,16.731,16.733,16.731h136.99     c9.245,0,16.729-7.492,16.729-16.731C170.452,301.208,162.968,293.718,153.723,293.718z" />
                  <path d="M170.452,226.79H66.926c-9.248,0-16.732,7.492-16.732,16.733c0,9.239,7.484,16.731,16.732,16.731h103.525     c9.25,0,16.734-7.492,16.734-16.731C187.186,234.281,179.702,226.79,170.452,226.79z" />
                  <path d="M203.919,176.594c0-9.238-7.483-16.731-16.732-16.731h-70.063c-9.252,0-16.734,7.493-16.734,16.731     c0,9.241,7.482,16.733,16.734,16.733h70.063C196.435,193.328,203.919,185.836,203.919,176.594z" />
                  <path d="M478.458,132.281c-6.801-7.956-16.699-12.514-27.178-12.514H259.455c-17.729,0-32.582,12.711-35.345,30.244     l-27.513,176.011c-1.599,10.325,1.374,20.8,8.167,28.741c6.801,7.956,16.699,12.517,27.178,12.517h191.826     c17.73,0,32.58-12.714,35.344-30.247l27.512-176.008C488.223,150.697,485.253,140.222,478.458,132.281z M426.038,331.854     c-0.178,1.135-1.13,1.961-2.27,1.961H231.942c-0.672,0-1.309-0.301-1.75-0.803c-0.439-0.512-0.62-1.198-0.521-1.853     l27.514-175.97c0.18-1.136,1.129-1.961,2.271-1.961h61.831l-8.04,43.295c-0.608,3.267,0.26,6.64,2.396,9.198     c2.127,2.566,5.283,4.043,8.613,4.043h38.908c5.393,0,10.03-3.846,11.01-9.148l8.811-47.386h68.295     c0.672,0,1.311,0.304,1.75,0.802c0.439,0.516,0.619,1.202,0.521,1.854L426.038,331.854z" />
                </g>
              </g>
            </g>
          </svg>
          <span>Free & Insured Delivery</span>
        </div>
        <div className="flex items-center gap-x-3 pb-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height={22}
            width={22}
            version="1.1"
            viewBox="0 0 512 512"
            xmlSpace="preserve"
            className="flip"
          >
            <g>
              <path
                d="M447.77,33.653c-36.385-5.566-70.629,15.824-82.588,49.228h-44.038v37.899h40.902   c5.212,31.372,29.694,57.355,62.855,62.436c41.278,6.316,79.882-22.042,86.222-63.341C517.428,78.575,489.07,39.969,447.77,33.653z   "
              />
              <path
                d="M162.615,338.222c0-6.88-5.577-12.468-12.468-12.468H96.16c-6.891,0-12.467,5.588-12.467,12.468   c0,6.868,5.576,12.467,12.467,12.467h53.988C157.038,350.689,162.615,345.091,162.615,338.222z"
              />
              <path
                d="M392.999,237.965L284.273,340.452l-37.966,9.398v-86.619H0v215.996h246.307v-59.454l35.547-5.732   c16.95-2.418,29.396-6.692,44.336-15.018l46.302-24.228v104.432h132.435V270.828C504.927,202.618,428.016,202.43,392.999,237.965z    M215.996,448.913H30.313v-155.37h185.683v63.805l-36.419,9.01c-15.968,4.395-25.708,20.518-22.174,36.696l0.298,1.247   c3.478,15.912,18.651,26.436,34.785,24.14l23.51-3.788V448.913z"
              />
            </g>
          </svg>
          <span>Hasle Free Returns</span>
        </div>
      </div>
      <Payment open={paymentModal} onOpenChange={onOpenChange} />
    </section>
  );
};

export default PaymentButton;
